<template>
  <div class="ui-wrap">
    <div class="ui-box">
      <div class="login">
        <div class="ipt">
          <input
            class="login-ipt"
            @focus="error = 0"
            type="text"
            :placeholder="$t('login.userenter')"
            v-model="name"
          />
          <p class="error" v-if="error === 1">{{ $t('common.accountTip1') }}</p>
          <p class="error" v-if="error === 2">{{ $t('common.accountTip2') }}</p>
        </div>
        <div class="psw">
          <input
            type="password"
            @focus="error = 0"
            class="login-ipt"
            :placeholder="$t('login.pswd')"
            v-model="psw"
          />
        </div>
        <div class="row">
          <div class="remenber">
            <label
              class="checkbox"
              :class="{ checked: remember === 1 }"
              @click="changeRemember"
              >{{ $t('login.remember') }}</label
            >
          </div>
          <div class="forget">
            <a class="link-forget" @click="info.show = true"
              >{{ $t('login.forget') }}？</a
            >
          </div>
        </div>
        <a class="ui-btn" @click="gologin">{{ $t('common.login') }}</a>
        <!-- <Other></Other> -->
      </div>
    </div>
    <div class="ui-pop" v-show="info.show">
      <div class="ui-mask"></div>
      <div class="ui-modal findPsw">
        <a class="modal-close" @click="info.show = false"
          ><i class="el-icon-close"></i
        ></a>
        <p class="modal-title">{{ $t('login.find') }}</p>
        <div class="content">
          <div class="ipt">
            <input
              class="login-ipt"
              type="text"
              :placeholder="$t('login.userenter')"
              v-model="info.mobileNO"
            />
            <!-- <span class="pre-num">+86</span> -->
          </div>
          <div class="code">
            <input
              class="login-ipt"
              type="text"
              v-model.number="info.smsCode"
              @focus="clearError(0)"
              :placeholder="$t('common.inputCode')"
            />
            <a class="getCode" v-show="!info.showtime" @click="sendSmsCode">{{
              $t('common.code')
            }}</a>
            <span v-show="info.showtime" class="time">{{ info.count }}s</span>
            <p class="ui-error" v-if="info.error === 1">
              {{ $t('common.codeTip') }}
            </p>
          </div>
          <!-- <smscode :info="info"></smscode> -->
          <div class="psw">
            <input
              type="password"
              class="login-ipt"
              :placeholder="$t('login.pswd')"
              v-model="info.newPwd"
            />
          </div>
          <div class="psw">
            <input
              type="password"
              class="login-ipt"
              :placeholder="$t('common.again')"
              v-model="info.newPwd2"
            />
          </div>
          <a class="ui-btn" @click="resetPsw">{{ $t('common.comfirm') }}</a>
          <a class="link-back" @click="info.show = false">{{
            $t('login.back')
          }}</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Other from '@/components/OtherLogin.vue'
import smscode from '@/components/Smscode.vue'
import { getBaseProfile } from '@/service/teacherApi.js'
import { getMyProfile } from '@/service/studentApi.js'
import {
  login,
  sendSmsCode,
  sendEmailCode,
  modifyPwdByMobile,
  modifyPwdByEmail,
  getAccessToken,
} from '@/service/loginAndRegistApi.js'
export default {
  components: { Other, smscode },
  data() {
    return {
      name: '',
      psw: '',
      remember: 0,
      error: 0, // 为0时没有错误，为1时，帐号或密码为空，为2时，帐号或密码不正确
      info: {
        show: false,
        mobileNO: '',
        smsCode: '',
        time: 0,
        count: 0,
        showtime: false,
        newPwd: '',
        newPwd2: '',
        checksum: '',
        error: false,
      },
      inter: '',
    }
  },
  methods: {
    async gologin() {
      if (this.name && this.psw) {
        let res = await login({ account: this.name, pwd: this.psw })
        if (res.data.status === 1) {
          sessionStorage.setItem('1to1token', res.data.token)
          let res2 = await getAccessToken()
          if (res2.data.status === 1) {
            sessionStorage.setItem('token3rd', res2.data.data.token3rd)
          }
          if (res.data.userName.length === 0) {
            if (res.data.userType === 10) {
              this.$router.push({ path: '/studentFill' })
            } else {
              this.$router.push({ path: '/teacherFill' })
            }
            this.$store.dispatch('SETUSER', { uid: res.data.uid })
          } else {
            let user = {
              loginState: true,
              userType: res.data.userType,
              uid: res.data.uid,
              userName: res.data.userName,
              userPhoto: res.data.userPhoto,
              state: '',
            }
            // console.log(res.data);
            // return false
            // 获取基本信息
            let res1
            if (res.data.userType === 20) {
              res1 = await getBaseProfile({ teacherId: res.data.uid })
              if (res1.data.status === 1) {
                user.state = res1.data.data.state
              }
            } else {
              res1 = await getMyProfile()
              if (res1.status === 200) {
                user.state = res1.data.state
              }
            }
            if (this.remember === 1) {
              localStorage.setItem('userName', this.name)
              localStorage.setItem('password', this.psw)
            } else {
              localStorage.setItem('userName', '')
              localStorage.setItem('password', '')
            }
            
            this.$store.dispatch('SETUSER', user)
            this.$router.push({ path: '/home' })
          }
        } else {
          this.error = 2
        }
      } else {
        this.error = 1
      }
    },
    changeRemember() {
      if (this.remember) {
        this.remember = 0
        localStorage.setItem('member', 0)
      } else {
        this.remember = 1
        localStorage.setItem('member', 1)
      }
    },
    async resetPsw() {
      const reg = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
      let res
      if (reg.test(this.info.mobileNO)) {
        this.info.email = this.info.mobileNO
        res = await modifyPwdByEmail(this.info)
      } else {
        res = await modifyPwdByMobile(this.info)
      }
      if (res.data.status === 1) {
        this.$message({ type: 'success', message: '密码修改成功！' })
        this.info.show = false
      }
    },
    async sendSmsCode() {
      if (this.info.count === 0 && this.info.mobileNO) {
        const reg = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
        let res
        if (reg.test(this.info.mobileNO)) {
          res = await sendEmailCode({ email: this.info.mobileNO })
        } else {
          res = await sendSmsCode({ mobileNO: this.info.mobileNO })
        }
        if (res.data.status === 1) {
          this.info.time = res.data.time
          this.info.checksum = res.data.checksum
          this.info.count = 60
          this.info.showtime = true
          this.inter = setInterval(() => {
            this.info.count--
            if (this.info.count === 0) {
              this.info.showtime = false
              clearInterval(this.inter)
            }
          }, 1000)
        }
      } else if (this.info.mobileNO.length === 0) {
        this.info.error = true
      }
    },
    clearError() {
      this.info.error = false
    },
  },
  mounted() {
    if (localStorage.getItem('member') == 1) {
      this.remember = 1
      if (localStorage.getItem('userName').length !== 0) {
        this.name = localStorage.getItem('userName')
        this.psw = localStorage.getItem('password')
      }
    }
  },
  destroyed() {
    clearInterval(this.inter)
  },
}
</script>
<style lang="scss" scoped>
.login {
  width: 450px;
  margin: 0 auto;
  padding: 90px 0 160px;
  .ui-btn {
    margin: 42px 0 89px;
    display: block;
  }
}
.login-ipt {
  width: 100%;
  height: 42px;
  border-radius: 42px;
  background: #ededed;
  border: 1px solid #ededed;
  padding: 10px 22px 10px 70px;
  line-height: 20px;
  &:focus {
    border-color: #002147;
  }
}
.ipt {
  position: relative;
  margin-bottom: 30px;
}
.pre-num {
  position: absolute;
  top: 12px;
  left: 17px;
}
.error {
  margin: 2px 20px -14px;
  font-size: 12px;
  color: red;
  line-height: 1;
}
.psw {
  margin-bottom: 20px;
  .login-ipt {
    background: #ededed url(../assets/psw.png) no-repeat 23px center;
  }
}
.ipt .login-ipt {
  background: #ededed url(../assets/user2.png) no-repeat 23px center;
  background-size: 16px auto;
}
.row {
  overflow: hidden;
  line-height: 16px;
  height: 16px;
}
.remenber {
  float: left;
}
.checkbox {
  font-size: 12px;
  color: #999;
  height: 16px;
  line-height: 16px;
  cursor: pointer;
  &:before {
    content: '';
    display: inline-block;
    width: 14px;
    height: 14px;
    vertical-align: top;
    margin: 1px 5px 0 0;
    border: 2px solid #767676;
    border-radius: 50%;
  }
  &.checked {
    &:before {
      background: url(../assets/gou.png);
      border: 0;
    }
  }
}
.forget {
  float: right;
  padding-right: 20px;
}
.link-forget {
  font-size: 12px;
  color: #999;
  &:hover {
    color: #666;
  }
}
.findPsw {
  width: 800px;
  height: 620px;
  .ui-btn {
    display: block;
    margin-top: 40px;
  }
}
.content {
  padding: 60px 200px 50px;
}
.code {
  margin-bottom: 30px;
  position: relative;
  .getCode,
  .time {
    position: absolute;
    top: 5px;
    right: 5px;
    height: 32px;
    background: #002147;
    border-radius: 32px;
    text-align: center;
    line-height: 32px;
    color: #fff;
    padding: 0 20px;
    min-width: 100px;
  }
  .time {
    background: #a0a0a0;
  }
  .login-ipt {
    padding: 10px 120px 10px 70px;
    background: #ededed url(../assets/phone3.png) no-repeat 23px center;
  }
}
.link-back {
  display: block;
  text-align: center;
  margin-top: 20px;
  line-height: 16px;
  color: #002147;
}
.code {
  margin-top: 30px;
  position: relative;
  .getCode,
  .time {
    position: absolute;
    top: 5px;
    right: 5px;
    height: 32px;
    background: #002147;
    border-radius: 32px;
    text-align: center;
    line-height: 32px;
    color: #fff;
    padding: 0 20px;
    min-width: 100px;
  }
  .time {
    background: #a0a0a0;
  }
  .login-ipt {
    padding: 10px 120px 10px 70px;
    background: #ededed url(../assets/phone3.png) no-repeat 23px center;
  }
}
</style>
<i18n>
{
  "cn": {
    "login": {
      "userenter": "请输入用户名",
      "pswd": "请输入密码",
      "remember": "记住密码",
      "forget": "忘记密码",
      "back": "返回登录",
      "find": "找回密码"
      
    }
  },
  "TW": {
    "login": {
      "userenter": "請輸入用戶名",
      "pswd": "請輸入密碼",
      "remember": "記住密碼",
      "forget": "忘記密碼",
      "back": "返回登入",
      "find": "找回密碼"
    }
  },
  "en": {
    "login": {
      "userenter": "Please enter email or mobile no. as your login name",
      "pswd": "Please enter your password",
      "remember": "Remember password",
      "forget": "Forgotten password?",
      "back": "Return to login",
      "find": "Retrieve password "
    }
  }
}
</i18n>